import { useContext } from 'react';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';
import { Modal, ThemeContext } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import { analytics } from '@/helpers/analytics';
import { useRequestCall } from '../RequestCall';
import RequestDemoModal3Form from './RequestDemoModal3Form';

import styles from './request-demo-modal-3.module.css';

const RequestDemoModal3 = ({
  open,
  onClose,
  title = 'Пробуйте бесплатно 7 дней',
  description = 'Заполните поля, чтобы получить и активировать пробный доступ к сервису для создания и управления документами.'
}) => {
  const { t } = useTranslation();
  const { lang, viewport } = useContext(ThemeContext);
  const isPhone = viewport === 'phone';

  const { onSubmit, isSuccess, isError, isLoading, reset } = useRequestCall({ lang });

  const handleSubmit = (values) => {
    onSubmit(values).then(success => {
      if (success) {
        analytics.sendRequestForm();
      }
    });
  };

  const closeModal = () => {
    reset();
    onClose();
  };

  return (
    <ClientWrap>
      <Modal
        open={open}
        onClose={closeModal}
        width="100%"
        maxWidth="560px"
        title={isPhone && title}
        viewStyle="no-padding"
        containerClassName={styles.container}
        contentClassName={styles.content}
      >
        <div className={styles.left}>
          <input type="hidden" autoFocus />
          {!isPhone && (
            <div className={styles.title}>{title}</div>
          )}
          {!(isError || isSuccess) && (
            <div className={styles.subtitle}>
              {description}
            </div>
          )}
          <RequestDemoModal3Form
            onSubmit={handleSubmit}
            isSendSuccess={isSuccess}
            isSendError={isError}
            isSendLoading={isLoading}
            buttonText={t('start_free')}
            noticeText={
              <Trans
                i18nKey="user_agreement_form_notice"
                components={{
                  privacy: <Link href="/privacy" target="_blank" />,
                  license: <Link href="/license" target="_blank" />,
                  button: t('start_free'),
                }}
              />
            }
          />
        </div>
      </Modal>
    </ClientWrap>
  );
};

export default RequestDemoModal3;
